export function getStatsUsersRoutes() {
  return [
    {
      path: "/stats/users",
      name: "stats-users",
      component: () => import(/* webpackChunkName: stats-users-old-backend */ "./components/StatsUserOld.vue"),
    },
  ]
}
